export default __webpack_public_path__ + "static/big-footer-0b6dad3316982044001f2313745d8916.svg";